var _a;
export var TEXT_ALIGNMENT_LEFT = 0;
export var TEXT_ALIGNMENT_CENTER = 1;
export var TEXT_ALIGNMENT_RIGHT = 2;
export var TEXT_ALIGNMENT_CLASS_NAMES = (_a = {},
    _a[TEXT_ALIGNMENT_LEFT] = 'left',
    _a[TEXT_ALIGNMENT_CENTER] = 'center',
    _a[TEXT_ALIGNMENT_RIGHT] = 'right',
    _a);
export var TEXT_ALIGNMENT_DEFAULT_CATEGORY = TEXT_ALIGNMENT_LEFT;
export var TEXT_ALIGNMENT_DEFAULT_HOMEPAGE = TEXT_ALIGNMENT_CENTER;
